// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_MJo","cls2":"AuthorsCard-cls2_n74 AuthorsCard-cls1_MJo","altLook":"AuthorsCard-altLook_7Jx"};